<template>
  <article
    class="content-header"
    :class="{
      'bg-type': bgType,
      'bg-height': bgHeight,
      'no-radius': noRadius,
      'mbtm-16': mbtm16,
      'mbtm-20': mbtm20,
      'mbtm-24': mbtm24,
      'mbtm-54': mbtm54,
      'bg-height2': titleImg2,
    }"
  >
    <div v-if="title" class="title">
      <h2 v-html="$t(title)"></h2>
    </div>
    <div v-if="description" class="description" v-html="$t(description)" />
    <div v-if="titleImg" class="title-img" :class="customerCss">
      <slot name="img" />
    </div>
    <div v-else-if="titleImg2" class="title-img2" :class="customerCss">
      <slot name="img2" />
    </div>
    <div v-else-if="titleImg3" class="title-img3" :class="customerCss">
      <slot name="img3" />
    </div>
    <div v-if="tabs">
      <slot name="tab" />
    </div>
    <div v-if="subtitle" class="title">
      <h5 v-html="$t(subtitle)" />
    </div>
    <div v-if="h3title" class="title mtop-8">
      <h3 v-html="$t(h3title)" />
    </div>
    <div v-if="description3" class="description3" v-html="$t(description3)" />
    <slot name="card" />
    <slot name="summary" />
  </article>
</template>
<style type="scss" scoped></style>
<script>
import { BaseComponent } from "@/components/base-component";
export default {
  name: "Badge",
  components: {},
  extends: BaseComponent,
  props: {
    // titleText: { type: [Boolean], default: false },
    // subtitleText: { type: [Boolean], default: false },
    // descriptionText: { type: [Boolean], default: false },
    // descriptionText3: { type: [Boolean], default: false },
    titleImg: { type: [Boolean], default: false },
    titleImg2: { type: [Boolean], default: false },
    titleImg3: { type: [Boolean], default: false },
    title: { type: String, default: "" },
    subtitle: { type: String, default: "" },
    // subtitle2: { type: String, default: "" },
    h3title: { type: String, default: "" },
    description: { type: String, default: "" },
    // description2: { type: String, default: "" },
    description3: { type: String, default: "" },
    tabs: { type: Boolean, default: false },
    img: { type: Boolean, default: false },
    bgType: { type: Boolean, default: false, required: false },
    noRadius: { type: Boolean, default: false, required: false },
    bgHeight: { type: Boolean, default: false, required: false },
    summary: { type: Boolean, default: false, required: false },
    mbtm16: { type: Boolean, default: false, required: false },
    mbtm20: { type: Boolean, default: false, required: false },
    mbtm24: { type: Boolean, default: false, required: false },
    mbtm54: { type: Boolean, default: false, required: false },
    customerCss: { type: String, default: "" },
  },
  data() {
    return {};
  },
};
</script>
